import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import red from '@material-ui/core/colors/red';
import Paper from '@material-ui/core/Paper';

import config from "../../config/config";
import axios from 'axios';

import MuiVirtualizedTable from '../CSSComponent/endlesstable'


const styles = theme => ({
    padding: {
        padding: `0 ${theme.spacing.unit * 2}px`,
    },
    card: {
        width: "100%",
        height: '68vh',
    },
    header: {
          textAlign: "center"
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    actions: {
        display: 'flex',
        height: 56
    },
    content: {
          textAlign: "center",
        height: '55vh',
        overflow: "auto"
    },
    actionContent: {
          textAlign: "center",
        height: '50vh',
        overflow: "auto"
    },
    expand: {
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: -8,
        },
    },
    transaction: {
        paddingTop: 10,
        overflow: "auto",
        height: "10vh"
    },
    expandOpen: {
        transform: 'rotate(180deg)'
    },
    avatar: {
        backgroundColor: red[500]
    }
});

class AttachmentList extends React.Component {
    constructor(props) {
        super(props);
    }

    handleFileDownload = (id, name) => {
        // axios.get().then(res=>{
        //     console.log(res);
        // }).catch(error => {console.log(error.response)})
        axios({
            url: config.rrattachmentdownload + id,
            method: 'GET',
            responseType: 'blob' // important
          }).then((response) => {
            // console.log(id)
            // console.log(name)
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', name);
            document.body.appendChild(link);
            link.click();
          }).catch(error => {console.log(error.response)});
    };



    render() {
        const { classes } = this.props
        const header = ['Last Modified', 'By']
        const headermapping = {'Last Modified': 'update_time', 'By': 'upload_by'}
        // {this.props.attachments ?}
        console.log(this.props.risk)
        return (
            <Paper style={{ height: 400, width: '100%' }}>
                {this.props.risk ?   <MuiVirtualizedTable
                    rowCount={this.props.risk.length}
                    rowGetter={({ index }) => this.props.risk[index]}
                    onRowClick={event => console.log(event)}
                    columns={[
                        {
                            width: 200,
                            flexGrow: 1.0,
                            label: 'Last Modified',
                            dataKey: 'update_time'
                        },
                        {
                            width: 120,
                            label: 'By',
                            dataKey: 'upload_by'
                        }
                    ]}
                /> : null}
            </Paper>
        )
    }
}

AttachmentList.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AttachmentList)


// WEBPACK FOOTER //
// ./src/components/Risks/AttachmentList.js